var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { HomePageWidgetTypes } from "@irati/types";
import FormattedMessage from "@irati/utils/lang";
import { HoverOverlay } from "../styled/styled";
import { StyledTile, TextWrapper, H3, P } from "../styled/imageWithText";
import EditWidget from "../EditWidget";
import MoveWidget from "../MoveWidget";
var WidgetImageWithText = /** @class */ (function (_super) {
    __extends(WidgetImageWithText, _super);
    function WidgetImageWithText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WidgetImageWithText.prototype.render = function () {
        var _a = this.props, widgetId = _a.widgetId, image = _a.image, header = _a.header, body = _a.body, link = _a.link, bgColor = _a.bgColor, color = _a.color, hoverActive = _a.hoverActive, removeTileFromGrid = _a.removeTileFromGrid, editTile = _a.editTile, isOnDrag = _a.isOnDrag, onClick = _a.onClick, openLinkInNewTab = _a.openLinkInNewTab;
        var isTempWidget = widgetId === "temp";
        return (React.createElement(StyledTile, { image: image, bgColor: bgColor, color: color, link: link, onDragActive: isOnDrag && hoverActive, hoverActive: hoverActive, onClick: function () { return onClick({
                widgetId: widgetId,
                link: link,
                openLinkInNewTab: openLinkInNewTab,
                tile_type: HomePageWidgetTypes.ImageWithText
            }); } },
            React.createElement(TextWrapper, { isTempWidget: isTempWidget }, isTempWidget ?
                (React.createElement(React.Fragment, null,
                    React.createElement(H3, null,
                        React.createElement(FormattedMessage, { id: header })),
                    React.createElement(P, null,
                        React.createElement(FormattedMessage, { id: body }))))
                : (React.createElement(React.Fragment, null,
                    React.createElement(H3, null, header),
                    React.createElement(P, null, body)))),
            hoverActive &&
                React.createElement(React.Fragment, null,
                    React.createElement(EditWidget, { widgetId: widgetId, image: image, header: header, link: link, body: body, editTile: editTile, openLinkInNewTab: openLinkInNewTab, type: "imageWithText", removeTileFromGrid: removeTileFromGrid }),
                    React.createElement(MoveWidget, null),
                    React.createElement(HoverOverlay, null))));
    };
    return WidgetImageWithText;
}(PureComponent));
export default WidgetImageWithText;
